<template>
  <div class="win">
    <div class="header">
      <div class="navItem" v-bind:class="{ active: activeTab === 0 }" @click="onTabChange(0)">
        <i class="iconfont el-icon-setting"></i>
        <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '' }">{{ $t("ems.basicConfiguration") }}</div>
      </div>
      <div class="navItem" v-bind:class="{ active: activeTab === 1 }" @click="onTabChange(1)">
        <i class="iconfont el-icon-setting"></i>
        <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '' }">北向接口配置</div>
      </div>
    </div>
    <div class="content" v-if="activeTab === 0" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
      <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-width="150px" label-position="left">
        <div style="margin-bottom: 20px">
          <el-form-item :label="$t('ems.isShowGlobalAlarmTip')">
            <el-input v-model="form.isShowGlobalAlarmTip" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input>
            <span style="margin-left: 10px; font-size: 12px; color: #606266">{{ $t("ems.isShowGlobalAlarmTip1") }}</span>
          </el-form-item>
          <el-form-item :label="$t('ems.showGlobalAlarmLevel')">
            <el-input v-model="form.showGlobalAlarmLevel" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input>
            <span style="margin-left: 10px; font-size: 12px; color: #606266">{{ $t("ems.showGlobalAlarmLevel1") }}</span>
          </el-form-item>
          <el-form-item :label="$t('ems.showGlobalAlarmPeriod')">
            <el-input v-model="form.showGlobalAlarmPeriod" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input> {{ $t("ems.minute") }}
            <span style="margin-left: 10px; font-size: 12px; color: #606266">{{ $t("ems.showGlobalAlarmPeriod1") }}</span>
          </el-form-item>
          <el-form-item :label="$t('ems.autoLoginOut')">
            <el-input v-model="form.webIdleLogoutTime" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input> {{ $t("ems.minute") }}
            <span style="margin-left: 10px; font-size: 12px; color: #606266">{{ $t("ems.autoLoginOutTips") }}</span>
          </el-form-item>
          <el-form-item :label="$t('ems.runningTimeSet')">
            <el-date-picker
              v-model="form.systemActivationDate"
              align="right"
              type="date"
              :placeholder="$t('ems.selectDate')"
              popper-class="dateDown"
              style="width: 400px"
              value-format="yyyy-MM-dd"
              :clearable="false"
            ></el-date-picker>
            <span style="margin-left: 10px; font-size: 12px; color: #606266">{{ $t("ems.runningTimeSetTips") }}</span>
          </el-form-item>
        </div>
        <div class="subminBox">
          <div class="btn btn_active" @click="reset">
            <i class="iconfont icon-reset"></i><span>{{ $t("ems.alarm.reset") }}</span>
          </div>
          <div class="btn btn_active" @click="save">
            <i class="iconfont icon-baocun"></i><span>{{ $t("ems.strategy.save") }}</span>
          </div>
        </div>
      </el-form>
    </div>
    <div class="content" v-if="activeTab === 1" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
      <el-form @submit.native.prevent class="table_header table_header1 tableSearchForm" :inline="true" size="small" label-width="150px" label-position="left">
        <div style="margin-bottom: 20px; position: relative">
          <div style="position: absolute; top: 10px; right: 10px ">
            <div class="btn btn_active" style="width: 150px" @click="resetOpenApi">
              <i class="iconfont icon-reset"></i><span>{{ $t("login.reboot") }}open-api</span>
            </div>
          </div>

          <div class="form-box">
            <div style="width: 100%; padding: 10px 0">发送给第三方平台配置</div>
            <el-form-item label="是否开启">
              <el-select v-model="configForm.openApiEnable" placeholder="请选择" style="width: 400px" popper-class="selectDown">
                <el-option label="开启" :value="true"> </el-option>
                <el-option label="关闭" :value="false"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实时数据发送周期" style="width: 100%">
              <el-input v-model="configForm.realDataSendDuration" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input> s
            </el-form-item>
            <el-form-item label="利润数据发送周期" style="width: 100%">
              <el-input v-model="configForm.profitSendDuration" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input> s
            </el-form-item>
            <el-form-item label="告警数据发送周期" style="width: 100%">
              <el-input v-model="configForm.alarmSendDuration" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input> s
            </el-form-item>
            <el-row>
              <el-col :span="10">
                <el-form-item label="MQTT地址">
                  <el-input v-model="configForm.threadMqtt.url" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="MQTT用户名">
                  <el-input v-model="configForm.threadMqtt.username" :placeholder="$t('ems.alarm.PleaseEnterContent')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="MQTT密码">
                  <el-input v-model="configForm.threadMqtt.password" :placeholder="$t('ems.alarm.PleaseEnterContent')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-box">
            <div style="width: 100%; padding: 10px 0">发送给老云平台配置</div>
            <el-form-item label="是否开启">
              <el-select v-model="configForm.emmsEnable" placeholder="请选择" style="width: 400px" popper-class="selectDown">
                <el-option label="开启" :value="true"> </el-option>
                <el-option label="关闭" :value="false"> </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-box">
            <div style="width: 100%; padding: 10px 0">发送给EMMS新云平台配置</div>
            <el-form-item label="是否开启">
              <el-select v-model="configForm.emmsCloudEnable" placeholder="请选择" style="width: 400px" popper-class="selectDown">
                <el-option label="开启" :value="true"> </el-option>
                <el-option label="关闭" :value="false"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="租户编号" style="margin-left: 14px" required>
              <el-input v-model="configForm.teantSn" :placeholder="$t('ems.alarm.PleaseEnterContent')"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="10">
                <el-form-item label="MQTT地址">
                  <el-input v-model="configForm.emmsMqtt.url" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="MQTT用户名">
                  <el-input v-model="configForm.emmsMqtt.username" :placeholder="$t('ems.alarm.PleaseEnterContent')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="MQTT密码">
                  <el-input v-model="configForm.emmsMqtt.password" :placeholder="$t('ems.alarm.PleaseEnterContent')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="subminBox">
          <div class="btn btn_active" @click="resetThreadMqttConfig">
            <i class="iconfont icon-reset"></i><span>{{ $t("ems.alarm.reset") }}</span>
          </div>
          <div class="btn btn_active" @click="saveThreadMqttConfig">
            <i class="iconfont icon-baocun"></i><span>{{ $t("ems.strategy.save") }}</span>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { saveSysConfig, getSysConfig, getThreadMqttConfig, updateThreadMqttConfig, restartOpenapi, systemActivationDate } from "@/api/spms";
import { setStore } from "@/utils/store";
import i18n from "@/lang";

export default {
  name: "mainSys",
  data() {
    return {
      opacity: 0,
      loading: false,
      form: {
        isShowGlobalAlarmTip: "",
        showGlobalAlarmLevel: "",
        showGlobalAlarmPeriod: "",
        webIdleLogoutTime: null,
      },
      oldForm: {},
      activeTab: 0,
      configForm: {
        openApiEnable: false,
        realDataSendDuration: "",
        profitSendDuration: "",
        alarmSendDuration: "",
        threadMqtt: {
          url: "",
          username: "",
          password: "",
        },
        emmsEnable: false,
        emmsCloudEnable: false,
        emmsMqtt: {
          url: "",
          username: "",
          password: "",
        },
      },
      oldConfigForm: {},
    };
  },
  computed: {
    ...mapGetters(["language"]),
  },
  created() {
    this.saveSysConfig();
  },
  mounted() {
    setTimeout(() => {
      this.opacity = 1;
    }, 200);
  },
  methods: {
    onTabChange(tab) {
      this.activeTab = tab;
      if (tab === 0) {
        this.saveSysConfig();
      } else {
        this.initThreadMqttConfig();
      }
    },
    save() {
      const params = { ...this.form };
      if (params.systemActivationDate !== this.oldForm.systemActivationDate) {
        this.$confirm(i18n.t("ems.runningTimeSetTips"), {
          confirmButtonText: i18n.t("ems.strategy.confirm"),
          cancelButtonText: i18n.t("ems.strategy.cancel"),
          type: "warning",
        })
          .then(() => {
            this.loading = true;
            saveSysConfig(params).then(() => {
              this.loading = false;
              systemActivationDate(params.systemActivationDate).then(() => {
                this.$message.success(i18n.t("index.updateSuccessful"));
              }).catch(err => {
                console.log(err)
              });

              this.saveSysConfig();
            });

          })
          .then(() => {});
      } else {
        this.loading = true;
        saveSysConfig(params).then(() => {
          this.loading = false;
          this.$message.success(i18n.t("index.updateSuccessful"));

          this.saveSysConfig();
        });
      }
    },
    reset() {
      this.saveSysConfig();
    },
    saveSysConfig() {
      getSysConfig().then((res) => {
        if (res && res.data && res.data.data) {
          this.form = res.data.data;
          this.oldForm = JSON.parse(JSON.stringify(res.data.data));
          setStore({
            name: "systemSet",
            content: res.data.data,
            type: "session",
          });
          this.$store.commit("SET_SYSTEMSET", res.data.data);
        }
      });
    },
    initThreadMqttConfig() {
      getThreadMqttConfig().then((res) => {
        if (res && res.data && res.data.data) {
          this.configForm = res.data.data;
          this.oldConfigForm = JSON.parse(JSON.stringify(res.data.data));
        }
      });
    },
    resetThreadMqttConfig() {
      this.configForm = JSON.parse(JSON.stringify(this.oldConfigForm));
    },
    saveThreadMqttConfig() {
      this.$confirm(i18n.t("ems.strategy.sureyouwanttodothis"), {
        confirmButtonText: i18n.t("ems.strategy.confirm"),
        cancelButtonText: i18n.t("ems.strategy.cancel"),
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          const params = { ...this.configForm };
          updateThreadMqttConfig(params).then((res) => {
            this.loading = false;
            if(res && res.data && res.data.success){
              this.$message.success(i18n.t("index.updateSuccessful"));
              this.initThreadMqttConfig();
              this.$confirm(i18n.t("systemSetting.confirmTips1"), {
                confirmButtonText: i18n.t("ems.strategy.confirm"),
                cancelButtonText: i18n.t("ems.strategy.cancel"),
                type: "warning",
                dangerouslyUseHTMLString: true
              }).then(() => {
                this.loading = true;
                restartOpenapi().then(() => {
                  this.loading = false;
                  this.$message.success(i18n.t("ems.strategy.OperationSuccessfulTip"));
                });
              }).then(() => {});
            }else{
              this.$message.error(i18n.t("ems.strategy.OperationFailedTip"));
            }
          });
        })
        .then(() => {});
    },
    resetOpenApi() {

      this.$confirm(i18n.t("ems.strategy.sureyouwanttodothis"), {
        confirmButtonText: i18n.t("ems.strategy.confirm"),
        cancelButtonText: i18n.t("ems.strategy.cancel"),
        type: "warning",
      })
              .then(() => {
                this.loading = true;
                restartOpenapi().then(() => {
                  this.loading = false;
                  this.$message.success(i18n.t("ems.strategy.OperationSuccessfulTip"));
                });
              })
              .then(() => {
              });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/site";
.win {
  width: 100%;
  height: 100%;
  .header {
    height: 52px;
    background-color: var(--nav_inner);
    position: relative;
    display: flex;
    .navItem {
      height: 100%;
      // color: $font_bright_blue_title;
      color: var(--nav_title);
      display: flex;
      align-items: center;
      transition: all 0.3s linear;
      cursor: pointer;
      i {
        font-size: 22px;
        margin: 3px 20px 0;
      }
      .title {
        letter-spacing: 3px;
        font-size: 22px;
      }
      .desc {
        margin-left: 24px;
        font-size: 16px;
        color: $_128_128_128;
      }
    }
    .active {
      color: $font_bright_blue_title;
    }
  }
  .content {
    overflow: hidden;
    height: calc(100% - 52px);
    box-sizing: border-box;
    padding: 20px;
    .table_header {
      height: 100%;
      background-color: var(--nav);
      border: #595959 solid 1px;
      box-sizing: border-box;
      padding: 80px 50px;
      color: var(--input_font);
      position: relative;
      .subminBox {
        text-align: center;
        position: absolute;
        bottom: 50px;
        left: 610px;
      }
    }

    .table_header1{
      padding: 50px 50px;
    }
  }

  .form-box{
    background:  var(--nav_inner);
    padding: 10px;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.table_header {
  .el-form-item__label {
    color: var(--input_font) !important;
    font-size: 16px !important;
  }

  .avatar-uploader {
    .el-upload {
      border: 1px dashed rgb(191, 191, 191);
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
}
</style>
